import { render } from "./screen.vue?vue&type=template&id=57aba422&scoped=true"
import script from "./screen.vue?vue&type=script&lang=js"
export * from "./screen.vue?vue&type=script&lang=js"

import "@/css/view.css?vue&type=style&index=0&id=57aba422&scoped=true&lang=css"
import "@/css/information.css?vue&type=style&index=1&id=57aba422&scoped=true&lang=css"
import "./screen.vue?vue&type=style&index=2&id=57aba422&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mr.Wu\\Desktop\\Files\\XiHe\\code\\xihe_levelexam_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57aba422"]])

export default __exports__